var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepairingRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#C7B34E",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3341 13.3348L10.0008 10.0014M9.33411 11.0014L11.0008 9.33477L9.00077 8.33477L8.33411 9.00144L9.33411 11.0014ZM19.3174 11.9848C19.6375 11.665 19.8577 11.259 19.9512 10.8164C20.0447 10.3737 20.0075 9.91335 19.8441 9.49144L18.8961 10.4394H17.5628V9.10611L18.5108 8.15811C18.0888 7.99433 17.6284 7.95681 17.1855 8.05012C16.7426 8.14342 16.3364 8.36352 16.0164 8.6836C15.6964 9.00368 15.4764 9.40992 15.3832 9.85283C15.29 10.2957 15.3276 10.7562 15.4914 11.1781L11.1781 15.4921C10.7562 15.3282 10.2957 15.2906 9.85283 15.3838C9.40992 15.477 9.00368 15.697 8.6836 16.017C8.36352 16.3371 8.14342 16.7433 8.05012 17.1861C7.95681 17.629 7.99433 18.0895 8.15811 18.5114L9.10544 17.5634H10.4388V18.8968L9.49077 19.8448C9.91261 20.0085 10.373 20.0461 10.8158 19.9529C11.2586 19.8597 11.6647 19.6398 11.9848 19.3199C12.3048 19 12.525 18.5939 12.6183 18.1512C12.7117 17.7084 12.6744 17.248 12.5108 16.8261L16.8254 12.5114C17.2472 12.6746 17.7072 12.7116 18.1496 12.6181C18.5921 12.5246 18.9978 12.3046 19.3174 11.9848Z",
    stroke: "#C7B34E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8672 15.6692L17.6032 19.4052C17.6868 19.4889 17.7861 19.5554 17.8954 19.6007C18.0047 19.6461 18.1219 19.6694 18.2402 19.6694C18.3585 19.6694 18.4757 19.6461 18.585 19.6007C18.6943 19.5554 18.7936 19.4889 18.8772 19.4052L19.4052 18.8772C19.4889 18.7936 19.5554 18.6943 19.6007 18.585C19.6461 18.4757 19.6694 18.3585 19.6694 18.2402C19.6694 18.1219 19.6461 18.0047 19.6007 17.8954C19.5554 17.7861 19.4889 17.6868 19.4052 17.6032L15.6692 13.8672",
    stroke: "#C7B34E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairingRequestIcon);
export default __webpack_public_path__ + "static/media/RepairingRequestIcon.32e903eee92eadd1d9e9dea8f716b7f8.svg";
export { ForwardRef as ReactComponent };